<template>
 
      
       <router-view v-if="authenticated || !$router.secure"/>
       <v-app v-else id="inspire" v-cloak>
          <core-toolbar></core-toolbar>
         <v-content>
        <v-container fluid fill-height>
          <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
             <form-login/>
            </v-flex>
          </v-layout>
        </v-container>
    </v-content>
       </v-app>
</template>

<script>

import {
  mapState, mapActions
} from 'vuex'

export default {
      data () {
        return {
            bottom: false,
            message: 'Hello Vue!',
            resizeInterval: 300,
            resizeTimer: null,
            position: {coords: {latitude: 0 , longitude: 0}}
        }
      },
      computed: {
          ...mapState('app', ['view']),
          ...mapState('auth', ['authenticated']),
          redir () {
          return this.$router.currentRoute.query.redir
        }
      },
    watch: {
        bottom(bottom) {
          if (bottom) {
            this.$bus.$emit('infinite-scroll')
          }
        },
        authenticated (value) {
           if (value && this.redir) {
             var redir = this.redir
             this.$router.replace({'query': null});
             
            // return this.$router.push('./' + redir)
           }
        }
      },
    created() {
        var self = this
        window.addEventListener('scroll', () => {
          self.bottom = self.bottomVisible()
        })
        window.addEventListener('resize', function() {
            if (self.resizeTimer) clearTimeout(self.resizeTimer)
            let y = document.documentElement.clientHeight
            let x = document.documentElement.clientWidth
            self.resizeTimer = setTimeout(function(){
                self.$bus.$emit('window-resize', x , y)    
            },self.resizeInterval)
            
            })
        this.$bus.$on('app-init',value => {
            if (self.redir) { 
             //self.$router.replace({'query': null});
             //return self.$router.push(self.redir)
            }
        })
     },
     destroyed () {
       //this.logout()
     },
      $bus : {
          "ready": function () {
            if (this.redir) { 
             var redir = this.redir
             this.$router.replace({'query': null});
             return this.$router.push(redir)
            }
          }
        },
     methods: {
       ...mapActions('auth', ['logout']),
      bottomVisible () {
          const scrollY = window.scrollY
          const visible = document.documentElement.clientHeight
          const pageHeight = document.documentElement.scrollHeight
          const bottomOfPage = visible + scrollY >= pageHeight - this.view.threshold
          return bottomOfPage || pageHeight < visible
        },
        getLocation() {
          var self = this
            if (navigator.geolocation)  navigator.geolocation.getCurrentPosition(function(position){
                self.position = position
                //console.log(position)
            });
        },
         gotoLogin() {
/*console.log('redirecting')
          if (this.$router.secure) this.$router.push({ path: '/login' , params: this.$router.currentRoute.params, query: this.$router.currentRoute.query}).catch(err => {
            console.log('all good')
            })*/
        }
    },
    sockets: {
       /* unauthorized (ss){
          console.log('APP unauthorized')
          this.gotoLogin()
      }*/
   }
}
</script>
<style>
#inspire.v-application {
   background: #f0f0f0!important;
}
.app-logo {
    height: 35px;
    /* margin-right: 15px; */
    position: absolute;
    margin-left: -45px;
    margin-top: -2px;
}
.app-logo.selected {
  margin-top: 6px!important;
}
  #app_toolbar {
    /*background: #7F99AC url(/img/header_bg.png) no-repeat top left;*/
    z-index:2!important;
  }
  .v-toolbar--prominent .v-toolbar__title {
    -ms-flex-item-align: center!important;
    align-self: center!important;
    padding-bottom: 0px;
    padding-left:45px;
}
.no-scroll,.v-dialog--persistent {
  overflow: hidden!important;
}

</style>